import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import translations from '../../i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {rosterErrors, sdoNs} from '@modules/constants-enumerate';
import {RosterUtils} from '@modules/roster-utils';

const ROW_ERRORS = {
  [rosterErrors.AMBIGUOUS]: true,
  [rosterErrors.DUPLICATE_EMAIL]: true,
  [rosterErrors.DUPLICATE_PHONE]: true,
  [rosterErrors.EMAIL_IN_USE_BY_ADMIN]: true,
  [rosterErrors.ID_MISMATCH]: true,
  [rosterErrors.ID_REUSE_MISMATCH]: true,
  [rosterErrors.INVALID_EMAIL]: true,
  [rosterErrors.INVALID_COUNTRY_CODE]: true,
  [rosterErrors.INVALID_EXTERNAL_ID_LENGTH]: true,
  [rosterErrors.INVALID_LANGUAGE]: true,
  [rosterErrors.INVALID_MONTH]: true,
  [rosterErrors.INVALID_PHONE]: true,
  [rosterErrors.INVALID_NAME]: true,
  [rosterErrors.INVALID_SWAP_OF_GROUP_LEVEL]: true,
  [rosterErrors.INVALID_YEAR]: true,
  [rosterErrors.NO_EMAIL_OR_PHONE]: true,
  [rosterErrors.REPLACEMENT_ID_MISMATCH]: true,
  [rosterErrors.REPLACEMENT_ID_USED]: true,
  [rosterErrors.REPLACEMENT_ID_ARCHIVED]: true,
  [rosterErrors.REQUIRED]: true,
  [rosterErrors.INVALID_REFERENCE]: true,
  [rosterErrors.MISSING_HEADER]: true,
  [rosterErrors.NOT_EQUAL_ERROR]: true,
  [rosterErrors.NO_SUCH_CHOICE_ERROR]: true,
  [rosterErrors.INVALID_PHONE_FORMAT_ERROR]: true,
  [rosterErrors.MISSING_FIELD_ERROR]: true,
  [rosterErrors.NO_SUCH_FIELD_ERROR]: true,
  [rosterErrors.ID_MISMATCH_NEW]: true,
  [rosterErrors.IS_BLANK_ERROR]: true,
  [rosterErrors.UNKNOWN_HEADER]: true,
  [rosterErrors.INVALID_USER_ROLE_REFERENCE]: true,
  [rosterErrors.INCOMPLETE_DELETION]: true,
  [rosterErrors.INVALID_CLASS_PARENT]: true,
  [rosterErrors.INVALID_ORG_STATUS]: true,
  [rosterErrors.INVALID_ORG_STRUCTURE]: true,
  [rosterErrors.INVALID_MANAGED_RECORD_STATUS]: true,
};

/**
 * @summary InvalidRowErrors
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('invalid-row-errors')
class InvalidRowErrors extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of InvalidRowErrors.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'invalid-row-errors';
  @property({type: Boolean})
  show = false;
  @property({type: Array})
  errors = [];
  @property({type: String, mapState: `${sdoNs.SESSION}.group_info.level`, store: storeInstance})
  group_info_level = 0;

  @property({type: Object, mapState: `${sdoNs.SESSION}.$myGroups`, store: storeInstance})
  $myGroups = {};

  @property({type: Number, mapState: `${sdoNs.SESSION}.$levels`, store: storeInstance})
  tierLevels = 0;

  @property({type: Number, mapState: `${sdoNs.SESSION}.$classLevel`, store: storeInstance})
  $classLevel = 0;

  @property({type: Object})
  roster = {};
  @property({type: Boolean})
  useActiveRoster = false;

  /**
   *
   * @param {Number|String} num
   */
  numberToExcelCol(num) {
    let mod = null;
    let column = '';
    while (num > 0) {
      mod = (num - 1) % 26;
      column = String.fromCharCode(65 + mod) + column;
      num = Math.floor((num - mod) / 26);
    }
    return column;
  }

  async getRosterTemplate() {
    await RosterUtils.getRosterTemplate('aofl');
  }

  mapStateProperties() {
    if (this.useActiveRoster) {
      const state = this.storeInstance.getState();

      this.show = state[sdoNs.USER_JOBS].$rosterRowError;
      if (this.show) {
        this.errors = state[sdoNs.USER_JOBS].$activeRosterJob.errors;
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.roster?.id) {
      this.useActiveRoster = false;
      this.show = this.hasRowError();
      if (this.show) {
        this.errors = this.roster.errors;
      }
    } else {
      this.useActiveRoster = true;
    }
  }

  hasRowError() {
    if (Array.isArray(this.roster?.errors) &&
      this.roster.errors.length > 0
    ) {
      return this.roster.errors.some((item) => ROW_ERRORS[item.type] || false);
    }
    return false;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    if (this.show) {
      return super.render({
        default: {template, styles: [styles]}
      });
    }
    return super.render({
      default: {template: () => '', styles: [':host {display: none;}']}
    });
  }
}

export default InvalidRowErrors;
